import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-diceIcons-D4',
    templateUrl: './D4.svg',
    styleUrls: ['./diceIcons-D4.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiceIconsD4Component { }
